import { BridgeFlagsManager, LocalFlagsManager } from '@databases/flags';
import { activityLogger } from '@databases/logs/activity-logger';
import { LocalPanelManager } from '@databases/panel/managers';
import { PluginsManager, type PluginsState } from '@databases/plugins';
import { type ContainerOverrideOptions } from '@databases/service-container';

import { isFeatureFlagEnabled } from '@canvas/client-feature-flags';
import { createPreviewPanelAFMBridge } from '@canvas/databases-bridge-api';

import { type ModeConfig } from '../types.ts';

/**
 * Creates a base mode configuration object with default dependency providers.
 */
export function createBaseModeConfig({
  plugins,
  dependencies = {},
  buildSelectionFeatures,
}: {
  plugins: PluginsState;
  dependencies?: Partial<Omit<ContainerOverrideOptions, 'Intl' | 'PluginsManager'>>;
  buildSelectionFeatures: ModeConfig['buildSelectionFeatures'];
}): ModeConfig {
  return {
    dependencies: {
      FlagsManager: () => {
        return isFeatureFlagEnabled('database-frontend-flags-over-bridge')
          ? new BridgeFlagsManager()
          : new LocalFlagsManager();
      },
      PluginsManager: () => new PluginsManager(plugins),
      PanelManager: () => new LocalPanelManager(activityLogger),
      PreviewPanelAFMBridge: () => createPreviewPanelAFMBridge(),
      ...dependencies,
    },
    buildSelectionFeatures,
  };
}
